export default {
	ren: '人',
	jiangong: '件，共',
	dingdanjine: '订单金额',
	bubaohandandu: '此金额不包含单独购买的辅营产品金额',
	shijizhifu: '实际支付',
	yincangquanbu: '隐藏全部',
	zhankaiquanbu: '展开全部',
	dingdanxiangqing: '订单详情',
	yizhifu: '已支付',
	caozuo: '操作',
	dingdanchuangjianshijian: '订单创建日期',
	ewaixingli: '购买额外行李',
	tianjiaxingli: '添加行李服务',
	zanweigoumaifuyingchanpin: "暂未购买辅营产品",
	xinglixinxi: '行李信息',
	buxuyao: '不需要',
	suoyouchengke: '所有乘客',
	weisuoyouchengkegoumai: '为所有乘客统一购买',
	weisuoyouchengkedandugoumai: '为每位乘客单独购买',
	qucheng: '去程',
	huicheng: '回程',
	fujiafuwu: '附加服务',
	xinglizonge: '行李总价'
};
